import styles from './Select.module.css';

interface SelectOption {
	value: string;
	label: string;
}

interface SelectProps {
	label: string;
	name: string;
	value: string;
	onChange: (value: string) => void;
	options: SelectOption[];
	placeholder?: string;
	error?: string;
	required?: boolean;
	disabled?: boolean;
	id?: string;
}

export function Select({
	label,
	name,
	value,
	onChange,
	options,
	placeholder,
	error,
	required = false,
	disabled = false,
	id,
}: SelectProps) {
	const selectId = id ?? name;

	return (
		<div className={styles.field}>
			<label htmlFor={selectId} className={styles.label}>
				{label}
				{required && <span className={styles.required}>*</span>}
			</label>
			<select
				id={selectId}
				name={name}
				value={value}
				onChange={(e) => onChange(e.target.value)}
				disabled={disabled}
				required={required}
				className={styles.select}
			>
				{placeholder && (
					<option value="" disabled>
						{placeholder}
					</option>
				)}
				{options.map((opt) => (
					<option key={opt.value} value={opt.value}>
						{opt.label}
					</option>
				))}
			</select>
			{error && <span className={styles.errorText}>{error}</span>}
		</div>
	);
}
